var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ctx.state.sidebarTab == 'ai'),expression:"ctx.state.sidebarTab == 'ai'"}],staticClass:"content ai"},[_c('AiChat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }